import React, { useEffect, useState } from "react";
// import { mainAction } from '../Redux/Actions';

// import { LINKErp, LINKDomain, API_END_POINT } from "../Services";
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";
const TinyMCEComp = ({
  onSelected = () => {},
  Level = 0,
  Values = "",
  height = 200,
}) => {
  const { quill, quillRef } = useQuill();
  useEffect(() => {
    if (quill) {
      quill.on("text-change", () => {
        const text = quill.root.innerHTML;
        onSelected(text);
      });

      let initialContent = quill.clipboard.convert(Values);
      quill.setContents(initialContent, "silent");
    }
  }, [quill]);

  useEffect(() => {
    if (quill) {
      quill.clipboard.dangerouslyPasteHTML(Values);
      onSelected(Values);
    }
  }, [Values]);

  const [imgfile, setimgfile] = useState(null);
  const clickUpImages = () => {};

  const ImagesChange = (e) => {};

  const [EmbleYoutube, setEmbleYoutube] = useState("");
  const addYoutube = () => {
    if (quill) {
      let initialContent = quill.clipboard.convert(EmbleYoutube);
      quill.setContents(initialContent, "silent");
    }
  };

  return (
    <>
      <div
        className="row ml-1"
        style={{
          width: "100%",
          backgroundColor: "while",
          position: "relative",
        }}
      >
        <div ref={quillRef} style={{ width: "100%", height: height + "px" }} />
      </div>
    </>
  );
};

export const TinyMCE = React.memo(TinyMCEComp);
